/** @flow */
export default {
  requiredRecipientsCount: 500,
};
